/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Image from "../components/image/Image";
import img1 from "../resources/images/donate/1.jpg";
import img2 from "../resources/images/donate/2.jpg";
import img3 from "../resources/images/donate/3.jpg";
import { DONUS } from "../words";

export default function Donate(props) {
  const nowMediaQuery = props.nowMediaQuery;
  const paypalRef = useRef(null);

  useEffect(() => {
    const scriptId = "paypal-sdk";

    const renderPayPalButton = () => {
      if (window.paypal && paypalRef.current) {
        window.paypal
          .Buttons({
            style: {
              shape: "pill",
              color: "gold",
              layout: "horizontal",
              label: "subscribe",
            },
            createSubscription: function (data, actions) {
              return actions.subscription.create({
                plan_id: "P-1Y873881DP9266911NAC47XA",
                quantity: 1,
              });
            },
            onApprove: function (data, actions) {
              alert(data.subscriptionID);
            },
          })
          .render(paypalRef.current);
      }
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src =
        "https://www.paypal.com/sdk/js?client-id=AWb89Do_cU4Ue-6LdNrhSjOBCKPrQzLd8C3YD9_jo-OGmrwtcJZRFdAr1BL4aFjF6jGw2GrQD-5I9JEQ&vault=true&intent=subscription";
      script.id = scriptId;
      script.async = true;
      script.setAttribute("data-sdk-integration-source", "button-factory");

      script.onload = renderPayPalButton;

      document.body.appendChild(script);
    } else {
      renderPayPalButton();
    }
  }, []);
  return (
    <div className="section">
      <section className="contents">
        <Box mt={"150px"}>
          <Typography
            variant="h4"
            className="bold"
            textAlign={"center"}
            letterSpacing={2}
            fontSize={25}
            mb={7}
          >
            “여러분의 따뜻한 후원금은 이렇게 사용됩니다.”
          </Typography>
          <Grid container justifyContent={"space-between"} mb={2}>
            <Grid
              size={{ xs: 12, sm: 12, md: 4 }}
              display={"flex"}
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              item
            >
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={2}>
                <Image disabledEffect alt={""} src={img1} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                식사 지원
              </Typography>
              <Typography
                variant="subtitle1"
                fontSize={17}
                textAlign={"center"}
                lineHeight={2}
              >
                취약계층에 무료 도시락을 제공합니다.
                <br /> 매주 월,수,금 따뜻한 한끼 식사를 나눠주세요
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 4 }}
              display={"flex"}
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              item
            >
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={2}>
                <Image disabledEffect alt={""} src={img2} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                긴급 지원
              </Typography>
              <Typography
                variant="subtitle1"
                fontSize={17}
                textAlign={"center"}
                lineHeight={2}
              >
                주거, 수급 상황, 질병 등 다양한 위기상황을
                <br />
                파악하고 필요한 연결과 지원을 제공합니다
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 4 }}
              display={"flex"}
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              item
            >
              <Box width={nowMediaQuery !== "mobile" ? "20vw" : "80vw"} mb={2}>
                <Image disabledEffect alt={""} src={img3} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                활동 지원
              </Typography>
              <Typography
                variant="subtitle1"
                fontSize={17}
                textAlign={"center"}
                lineHeight={2}
              >
                당사자 돌봄 활동을 통해 자신감을 회복하고
                <br />
                삶의 질 향상에 기여하고 있습니다.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </section>
      <section className="contents" style={{ justifyContent: "left" }}>
        <Typography variant="h5" color="black" mb={2}>
          <strong className="blue">정기후원</strong>
        </Typography>
        <Box
          sx={{
            border: "1px solid #D3D3D3",
            p: 2,
          }}
        >
          <Typography variant="subtitle1" fontSize={17} lineHeight={2} mb={1}>
            정기후원은 매달 일정 금액을 자동으로 후원하여 어려운 이웃들에게
            지속적인 지원을 제공하는 방법입니다.
            <br />
            자동이체로 편리하게, 지속적인 지원으로 더 큰 변화를 만들 수
            있습니다.
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <a href={DONUS} target="_blank" rel="noreferrer">
              <Typography
                variant="h4"
                fontSize={17}
                className="bold"
                fontWeight={400}
                lineHeight={1.4}
                backgroundColor="lightgray"
                textAlign={"center"}
                px={4}
                py={2}
                borderRadius={10}
                mr={3}
                width={"220px"}
              >
                국내 정기후원
              </Typography>
            </a>
            <a
              href="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-1Y873881DP9266911NAC47XA"
              target="_blank"
              rel="noreferrer"
            >
              <Typography
                width={"220px"}
                sx={{}}
                variant="h4"
                fontSize={17}
                className="bold"
                fontWeight={400}
                lineHeight={1.4}
                backgroundColor="#FFC439"
                textAlign={"center"}
                px={4}
                py={2}
                borderRadius={10}
                mr={10}
              >
                Monthly Donation from Overseas
              </Typography>
            </a>
          </Box>
        </Box>
      </section>
      <section
        className="contents"
        style={{ justifyContent: "left", marginBottom: "20px" }}
      >
        <Typography variant="h5" color="black" mb={2}>
          <strong className="blue">특별후원</strong>
        </Typography>
        <Box sx={{ border: "1px solid #D3D3D3", p: 2 }}>
          <Typography variant="subtitle1" fontSize={17} lineHeight={2} mb={1}>
            특별후원은 원하는 날짜에 원하는 금액으로 한번 지원할 수 있는
            방법입니다.
            <br />
            부담없이 자유롭게, 언제든지 쉽게 지원할 수 있습니다.
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <a href={DONUS} target="_blank" rel="noreferrer">
              <Typography
                variant="h4"
                fontSize={17}
                className="bold"
                fontWeight={400}
                lineHeight={1.4}
                backgroundColor="lightgray"
                textAlign={"center"}
                px={4}
                py={2}
                borderRadius={10}
                mr={3}
                width={"220px"}
              >
                국내 특별후원
              </Typography>
            </a>
            <a
              href="https://www.paypal.com/ncp/payment/FM2Y8P49ZBKQG"
              target="_blank"
              rel="noreferrer"
            >
              <Typography
                width={"220px"}
                sx={{}}
                variant="h4"
                fontSize={17}
                className="bold"
                fontWeight={400}
                lineHeight={1.4}
                backgroundColor="#FFC439"
                textAlign={"center"}
                px={4}
                py={2}
                borderRadius={10}
                mr={10}
              >
                One-time Donate from Overseas
              </Typography>
            </a>
          </Box>
        </Box>
      </section>
      <section
        className="contents"
        style={{ justifyContent: "left", marginBottom: "20px" }}
      >
        <Typography variant="h5" color="black" mb={2}>
          <strong className="blue">물품후원</strong>
        </Typography>
        <Box sx={{ border: "1px solid #D3D3D3", p: 2 }}>
          <Typography variant="subtitle1" fontSize={17} lineHeight={2} mb={1}>
            물품후원은 따뜻한 한 끼의 온기를 전하기 위해, 식재료와 생필품을
            나누는 방법입니다.
            <br />
            아래의 신청 링크를 통해 신청해주시면, 협의를 거쳐 기부 가능 여부를
            안내해드립니다.
          </Typography>
          <a
            target="_blank"
            href="https://cafe.naver.com/f-e/cafes/31387977/menus/16?viewType=L"
            rel="noreferrer"
          >
            <Typography
              variant="h4"
              fontSize={17}
              className="bold"
              fontWeight={400}
              lineHeight={1.4}
              backgroundColor="lightgray"
              textAlign={"center"}
              px={4}
              py={2}
              borderRadius={10}
              mr={10}
              width={"220px"}
            >
              물품후원 신청하기
            </Typography>
          </a>
        </Box>
      </section>
      <section
        className="contents"
        style={{ justifyContent: "left", marginBottom: "20px" }}
      >
        <Box sx={{ p: 2, backgroundColor: "#F2F2F2" }}>
          <Typography variant="h5" color="black" mb={2}>
            <strong>기부금영수증</strong>
          </Typography>
          <Typography variant="subtitle1" fontSize={17} lineHeight={2} mb={1}>
            기부해 주신 후원금(물품)은 지정기부금으로 처리되며, 기부금 영수증
            발급이 가능합니다.
            <br />
            아래의 신청 링크를 통해 양식을 작성해주시면 최대한 빠르게 발행해
            드리겠습니다.
          </Typography>
          <a
            target="_blank"
            href="https://cafe.naver.com/f-e/cafes/31387977/menus/20?viewType=L"
            rel="noreferrer"
          >
            <Typography
              variant="h4"
              fontSize={17}
              className="bold"
              fontWeight={400}
              lineHeight={1.4}
              backgroundColor="lightgray"
              textAlign={"center"}
              px={4}
              py={2}
              borderRadius={10}
              mr={10}
              width={"230px"}
            >
              기부금영수증 신청하기
            </Typography>
          </a>
        </Box>
      </section>
    </div>
  );
}
